import React, { useState } from 'react';
import { useUpdateBatiment } from '../hooks/useBatiments';

interface BulkUpdateBatimentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedBatiments: any[];
  onSuccess: () => void;
}

const BulkUpdateBatimentsModal: React.FC<BulkUpdateBatimentsModalProps> = ({
  isOpen,
  onClose,
  selectedBatiments,
  onSuccess
}) => {
  const [formData, setFormData] = useState({
    trigram: '',
    nombreEtages: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const updateBatiment = useUpdateBatiment();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const updatePromises = selectedBatiments.map(batiment => 
        updateBatiment.mutateAsync({
          id: batiment.id,
          data: {
            ...(formData.trigram && { trigram: formData.trigram }),
            ...(formData.nombreEtages && { nombreEtages: parseInt(formData.nombreEtages) })
          }
        })
      );

      await Promise.all(updatePromises);
      onSuccess();
      onClose();
    } catch (error) {
      console.error('Erreur lors de la mise à jour en masse:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <h2 className="text-lg font-semibold mb-4">
          Modifier {selectedBatiments.length} bâtiment{selectedBatiments.length > 1 ? 's' : ''}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Trigramme
            </label>
            <input
              type="text"
              value={formData.trigram}
              onChange={(e) => setFormData({ ...formData, trigram: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Ex: B1"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nombre d'étages
            </label>
            <input
              type="number"
              min="1"
              max="10"
              value={formData.nombreEtages}
              onChange={(e) => setFormData({ ...formData, nombreEtages: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Ex: 3"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 transition-colors"
            >
              {isLoading ? 'Modification...' : 'Modifier'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BulkUpdateBatimentsModal;
